import "./Footer.scss";
import Button from "components/Button/Button";
import NavMenu from "components/NavMenu/NavMenu";
import CopyrightSection from "components/CopyrightSection/CopyrightSection";
import { scrollToSection } from "utils/scroll";
import { useTranslation, Trans } from "react-i18next";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import FB from "assets/icons/FB.svg";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-container">
      <div className="footer-area">
        <div className="request-area">
          <div className="request-text">
            <Trans i18nKey={"content.leaveARequest"} components={{ span: <span /> }} />
          </div>
          <Button
            className="blue-btn"
            btnName={t("buttons.startNow")}
            onClick={() => {
              scrollToSection("home");
            }}
          />
        </div>
        <div className="footer-action">
          <NavMenu />
          <div className="social-media">
            <a
              href="https://t.me/paypilotglobal"
              target="_blank"
              rel="noreferrer"
            >
              <TelegramIcon fontSize="medium" />
            </a>
            <a
              href="https://www.instagram.com/paypilot.global/"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon fontSize="medium" />
            </a>
            <a
              href="https://www.facebook.com/paypilot.global"
              target="_blank"
              rel="noreferrer"
            >
              <img src={FB} alt="Facebook" />
            </a>
            <a
              href="https://www.linkedin.com/company/paypilot-global/posts/?feedView=all"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon fontSize="medium" />
            </a>
            <a
              href="https://x.com/paypilot_app"
              target="_blank"
              rel="noreferrer"
            >
              <XIcon fontSize="medium" />
            </a>
          </div>
        </div>
        <div className="footer-text">{t('footer.owner')}</div>
        <CopyrightSection />
      </div>
    </div>
  );
};
export default Footer;
